import { useSelector } from '../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

export const mapSettingsGroupingActiveGroupColumnsSelector = (state: AppState) => state.map.mapSettings.data.grouping.activeGroupColumns;
export const useMapSettingsGroupingActiveGroupColumnsSelector = () => useSelector(mapSettingsGroupingActiveGroupColumnsSelector);
